import SvgBed from "@clayton-homes/ui-icons/24/bed";
import SvgCheckmark from "@clayton-homes/ui-icons/24/checkmark";
import SvgHome from "@clayton-homes/ui-icons/24/home";
import SvgOven from "@clayton-homes/ui-icons/24/oven";
import { ReactElement } from "react";

type Status = "active" | "inactive" | "done";
interface StepProps {
	step: "size" | "beds" | "features";
}
interface StepStatus {
	size: Status;
	beds: Status;
	features: Status;
}
interface StatusProps {
	status: Status;
	icon: ReactElement;
}

function getStepStatus(step: StepProps["step"]): StepStatus {
	switch (step) {
		case "size":
			return {
				size: "active",
				beds: "inactive",
				features: "inactive",
			};
		case "beds":
			return {
				size: "done",
				beds: "active",
				features: "inactive",
			};
		case "features":
			return {
				size: "done",
				beds: "done",
				features: "active",
			};
	}
}

export default function ModelFinderProgress({ step }: StepProps) {
	const status = getStepStatus(step);

	return (
		<div className="flex items-center justify-center gap-2">
			<ModelFinderProgressIcon status={status.size} icon={<SvgHome />} />
			<span
				className={`${status.beds !== "inactive" ? "" : "opacity-25"} h-0 w-10 border-b-2 border-primary-500`}
			/>
			<ModelFinderProgressIcon status={status.beds} icon={<SvgBed />} />
			<span
				className={`${status.features !== "inactive" ? "" : "opacity-25"} h-0 w-10 border-b-2 border-primary-500`}
			/>
			<ModelFinderProgressIcon status={status.features} icon={<SvgOven />} />
		</div>
	);
}

function ModelFinderProgressIcon({ status, icon }: StatusProps) {
	return (
		<span
			className={`${status === "done" ? "bg-primary-500 text-white" : "bg-white text-primary-500"} ${status === "inactive" ? "bg-transparent opacity-25" : ""} flex h-12 w-12 justify-center rounded-full border-2 border-primary-500 p-[6px]`}
		>
			{status !== "done" ? icon : <SvgCheckmark />}
		</span>
	);
}
